<template>
  <Page>
    <LoadSheetReviewsView />
  </Page>
</template>

<script setup lang="ts">
import Page from '@/shared/components/layouts/Page.vue';
import LoadSheetReviewsView from '../../components/LoadSheetReviewsView.vue';

definePage({
  meta: {
    title: 'Load Sheet Reviews',
  },
});
</script>